import { useUserContext } from "hooks";
import useQuery from "hooks/useQuery";
import { useMemo } from "react";
import RemoteConfigService from "services/RemoteConfigService";

export const REMOTE_ANNOUNCEMENT_KEY = "HUB_ANNOUNCEMENT_TEXT";

function useRemoteAnnouncementMessage() {
  const [{ user }] = useUserContext();

  const queryKey = useMemo(() => [REMOTE_ANNOUNCEMENT_KEY, user?.uid], [user?.uid]);

  const { data, status } = useQuery(queryKey, ([key]) => RemoteConfigService.getStringValue(key));

  return useMemo(() => ({ status, message: data ?? "" }), [status, data]);
}

export default useRemoteAnnouncementMessage;
